import { render } from "./ProposalFeedback.vue?vue&type=template&id=d98a8026&scoped=true"
import script from "./ProposalFeedback.vue?vue&type=script&lang=js"
export * from "./ProposalFeedback.vue?vue&type=script&lang=js"

import "./ProposalFeedback.vue?vue&type=style&index=0&id=d98a8026&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d98a8026"]])

export default __exports__